import { FC, ReactElement, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Layout from "components/layout";
import Home from "@/page/Home";
import Recover from "@/page/Recover";
import Success from "@/page/Success";
import Failure from "@/page/Failure";
import Certification from "@/page/Certification";
import Succeed from "@/page/Succeed";
import Verifying from "@/page/Verifying";
import Compare from "@/page/Compare";
import CompareFailure from "@/page/CompareFailure";
import CompareSuccess from "@/page/CompareSuccess";
import CompareVerifying from "@/page/CompareVerifying";
import { messageWithApp } from "@/common/utils/messageWithApp";

const MainRoute: FC = (): ReactElement => {
  useEffect(() => {
    messageWithApp({
      type: "history-state-changed",
      navState: { title: "DID" },
    });
  }, []);
  return (
    <Layout>
      <Switch>
        <Route path="/home" component={Home} />
        <Route path="/recover" component={Recover} />
        <Route path="/success" component={Success} />
        <Route path="/succeed" component={Succeed} />
        <Route path="/verifying" component={Verifying} />
        <Route path="/failure" component={Failure} />
        <Route path="/certification" component={Certification} />
        <Route path="/compare" component={Compare} />
        <Route path="/compare-failure" component={CompareFailure} />
        <Route path="/compare-success" component={CompareSuccess} />
        <Route path="/compare-verifying" component={CompareVerifying} />
        <Route exact path={"*"} render={() => <Redirect to="/home" />} />
      </Switch>
    </Layout>
  );
};
export default MainRoute;
